import { get, post, patch, del } from './client.js';

const base = (wsId) => `/workspaces/${wsId}/crm-pipelines`;

export const list       = (wsId)                  => get(base(wsId));
export const create     = (wsId, body)             => post(base(wsId), body);
export const findOne    = (wsId, pipelineId)       => get(`${base(wsId)}/${pipelineId}`);
export const update     = (wsId, pipelineId, body) => patch(`${base(wsId)}/${pipelineId}`, body);
export const remove     = (wsId, pipelineId)       => del(`${base(wsId)}/${pipelineId}`);
